"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var custom_data_1 = require("../../model/custom-data");
var of_1 = require("rxjs/observable/of");
var custom_option_1 = require("../../model/custom-option");
var meta_knowledge_provider_service_1 = require("../api/meta-knowledge-provider.service");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var root_category_provider_service_1 = require("../api/root-category-provider.service");
var HttpCustomOptionProviderService = /** @class */ (function () {
    function HttpCustomOptionProviderService(metaKnowledgeProviderService, kbService, currentLanguageProvider, rootCategoryProviderService) {
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        this.kbService = kbService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.rootCategoryProviderService = rootCategoryProviderService;
    }
    HttpCustomOptionProviderService.prototype.getCustomOptionsProvider = function (category1, category2) {
        var _this = this;
        return this.rootCategoryProviderService.getRootCategoryId(category1).pipe(operators_1.switchMap(function (rootCategory) { return _this.metaKnowledgeProviderService.getPartyDefinitions(rootCategory); }), operators_1.map(function (partyDefinitions) {
            if (partyDefinitions && (category2 === partyDefinitions.category)) {
                return _this.getPartyOptions();
            }
            else {
                return [];
            }
        }));
    };
    HttpCustomOptionProviderService.prototype.provide = function (key, category1, instanceId1, data1, category2, subCategory1, subData1) {
        switch (key) {
            case 'parties':
            case 'participants':
            case 'partiesAndParticipants':
                return this.getRootEntityParties(key, data1, category1, category2);
            default:
                return of_1.of([]);
        }
    };
    HttpCustomOptionProviderService.prototype.getRootEntityParties = function (key, data1, category1, category2) {
        var partyDefinitions$ = this.metaKnowledgeProviderService.getPartyDefinitions(category1);
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        var nameMetaFields$ = this.kbService.getNameMetaFieldIds(category2);
        return Observable_1.Observable.zip(partyDefinitions$, currentLanguage$, nameMetaFields$)
            .pipe(operators_1.map(function (_a) {
            var partyDefinitions = _a[0], currentLanguage = _a[1], nameMetaFields = _a[2];
            if (partyDefinitions.category === category2) {
                var currentLanguageId_1 = currentLanguage.getId();
                var caseParties = data1.getProperty(partyDefinitions.parties.field).value;
                var caseParticipants = data1.getProperty(partyDefinitions.participants.field).value;
                var partySubEntities = [];
                switch (key) {
                    case 'parties':
                        partySubEntities.push.apply(partySubEntities, caseParties);
                        break;
                    case 'participants':
                        partySubEntities.push.apply(partySubEntities, caseParticipants);
                        break;
                    case 'partiesAndParticipants':
                        partySubEntities.push.apply(partySubEntities, caseParties.concat(caseParticipants));
                        break;
                }
                var activeParties_1 = [];
                partySubEntities.forEach(function (subEntity) {
                    var isActive = subEntity.getProperty(partyDefinitions.isActiveField).value;
                    if (isActive) {
                        var party_1 = subEntity.hasProperty(partyDefinitions.parties.partyField)
                            && subEntity.getProperty(partyDefinitions.parties.partyField).value
                            ||
                                subEntity.hasProperty(partyDefinitions.participants.partyField)
                                    && subEntity.getProperty(partyDefinitions.participants.partyField).value
                            ||
                                subEntity.hasProperty(partyDefinitions.advocates.partyField)
                                    && subEntity.getProperty(partyDefinitions.advocates.partyField).value;
                        var partyName = nameMetaFields.map(function (metaField) {
                            var value = party_1.getProperty(metaField.getSystemName()).value;
                            if (typeof value === 'string') {
                                return value;
                            }
                            else {
                                return value[currentLanguageId_1];
                            }
                        }).join(' ');
                        if (!(party_1.getInstanceId() in activeParties_1.map(function (activeParty) { return activeParty.id; }))) {
                            activeParties_1.push(new custom_option_1.CustomOption(partyName, party_1.getInstanceId()));
                        }
                    }
                });
                return activeParties_1;
            }
            else {
                return [];
            }
        }));
    };
    HttpCustomOptionProviderService.prototype.getPartyOptions = function () {
        return [
            new custom_data_1.CustomData('Parties', 'parties', []),
            new custom_data_1.CustomData('Participants', 'participants', []),
            new custom_data_1.CustomData('Parties and Participants', 'partiesAndParticipants', [])
        ];
    };
    HttpCustomOptionProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [meta_knowledge_provider_service_1.MetaKnowledgeProviderService,
            idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            root_category_provider_service_1.RootCategoryProviderService])
    ], HttpCustomOptionProviderService);
    return HttpCustomOptionProviderService;
}());
exports.HttpCustomOptionProviderService = HttpCustomOptionProviderService;
//# sourceMappingURL=http-custom-option-provider.service.js.map